"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var i18next_1 = require("i18next");
var apiService_1 = __importStar(require("@common/services/apiService"));
var __1 = __importDefault(require(".."));
var i18n_1 = __importDefault(require("@/react-app/i18n"));
var notifier_1 = __importDefault(require("@/react-app/common/utils/notifier"));
function default_1(_a) {
    var _this = this;
    var domain = _a.domain, angularJsDependencies = _a.angularJsDependencies;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    var _b = __read((0, react_1.useState)({
        notice: { enabled: false, severity: 'GOOD' },
        wordHighlighting: { enabled: false },
        enabled: true,
        result: 'NOTHING',
        rule: '',
    }), 2), ruleState = _b[0], setRuleState = _b[1];
    var cancel = function () {
        angularJsDependencies.go('app.assignment.automation.filters', {
            domain: domain,
        });
    };
    var createRule = function () { return __awaiter(_this, void 0, void 0, function () {
        var cleanRulePayload, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!ruleState) {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    cleanRulePayload = __assign(__assign({}, ruleState), { decisionId: ruleState.result === 'REFUSE' ? ruleState.decisionId : undefined });
                    return [4 /*yield*/, apiService_1.default.postRule({ domain: domain }, cleanRulePayload)];
                case 2:
                    _a.sent();
                    notifier_1.default.success(i18n_1.default.t('AUTOMATION.DECISION_RULES.RULE_BUILDER.SUCCESS_CREATE_TEXT_REACT', { filterName: ruleState.name }));
                    angularJsDependencies.go('app.assignment.automation.filters', {
                        domain: domain,
                    });
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    if ((0, apiService_1.isApiError)(error_1) && error_1.status === 401) {
                        notifier_1.default.error(i18n_1.default.t('AUTOMATION.DECISION_RULES.ERROR.SAVE_ERROR'));
                        console.error(error_1);
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement("div", { className: "filter-create content" },
        react_1.default.createElement(__1.default, { ruleState: ruleState, setRuleState: setRuleState, domain: domain, onCancel: cancel, onSave: createRule, headerText: (0, i18next_1.t)('AUTOMATION.DECISION_RULES.RULE_BUILDER.NEW_TITLE'), buttonText: (0, i18next_1.t)('AUTOMATION.DECISION_RULES.BTN.CREATE_RULE') })));
}
exports.default = default_1;
